// extracted by mini-css-extract-plugin
export default {"zoomModal":"N3-z","image":"O3-z","button":"P3-z","isOverlayShown":"Q3-z"};